import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import { AppStorageService } from './app-storage.service';
import { StorageKeys } from './storage-keys';

@Injectable({
  providedIn: 'root',
})
export class UserStateService {
  private userSubject = new BehaviorSubject<any>({});
  user$ = this.userSubject.asObservable();

  constructor(private storage: AppStorageService) {
    const user = this.storage.getJSON(StorageKeys.USER) || {};
    this.userSubject.next(user);
  }

  // Actualiza el usuario en el storage y emite el nuevo valor
  updateUser(user: any) {
    if (user) {
      this.storage.setJSON(StorageKeys.USER, user);
    } else {
      this.storage.remove(StorageKeys.USER);
    }
    this.userSubject.next(user || {});
  }
}
